import type {PostCheckoutRecurrenceModel, PostCheckoutRecurrenceParams} from 'domain/usecases';
import {makePostCheckoutRecurrence} from 'main/factories/usecases';

export const postCheckoutRecurrence = async (
	params: Omit<PostCheckoutRecurrenceParams, 'signal'>,
): Promise<PostCheckoutRecurrenceModel> => {
	const response = await makePostCheckoutRecurrence().post(params);

	return response;
};
